import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import React, { useState, useEffect } from "react";

import Home from "./user/pages/Home";
import About from "./user/pages/About";
import Category from "./user/pages/Category";
import Blog from "./user/pages/Blog";
import AllBlogs from "./user/pages/AllBlogs";
import Contact from "./user/pages/Contact";
import UserLogin from "./user/pages/UserLogin";
import UserSignup from "./user/pages/UserSignup";
import MyBlogs from "./user/pages/MyBlogs";
import CreateBlogs from "./user/pages/CreateBlogs";
import Product from "./user/pages/Product";
import ProductSlug from "./user/pages/ProductSlug";
import Checkout from "./user/pages/Checkout";
import AccountOrder from "./user/pages/account/AccountOrder";
import AccountOrderView from "./user/pages/account/AccountOrderView";
import Accountprofile from "./user/pages/account/Accountprofile";
import AccountPassword from "./user/pages/account/AccountPassword";
import AccountSupport from "./user/pages/account/AccountSupport";
import AccountPlan from "./user/pages/account/AccountPlan";
import Account from "./user/pages/account/Account";
import AccountAllEnquire from "./user/pages/account/AccountAllEnquire";
import AccountAllTransactions from "./user/pages/account/AccountAllTransactions";
import CartPage from "./user/pages/Cart";
import CompleteOrder from "./user/pages/CompleteOrder";
import WishList from "./user/pages/WishList";
import Comparsion from "./user/pages/Comparsion";
import Page from "./user/pages/Page";
import Cancel from "./user/pages/Cancel";
import SignupUserType from "./user/pages/SignupUserType";

import ErrorPage from "./user/pages/ErrorPage";

import { Toaster } from "react-hot-toast";

import { BlogProvider } from "./fetchdata/BlogContext";

import usePreventZoom from "./helper/usePreventZoom";
import getCookie from "./helper/getCookie";
import AllVendors from "./user/pages/vendor/AllVendors";
import ViewVendor from "./user/pages/vendor/ViewVendor";
import getDecryptData from "./helper/getDecryptData";
import AllPlans from "./user/pages/vendor/AllPlans";
import CheckoutPlan from "./user/pages/CheckoutPlan";
import CardView from "./user/pages/CardView";
import SuccessPage from "./user/pages/vendor/SuccessPage";
import FailPage from "./user/pages/vendor/FailPage";
import AccountprofileNew from "./user/pages/account/AccountprofileNew";
import HomeLocation from "./user/pages/HomeLocation";

import CategoryTest from "./user/pages/CategoryTest";
import ProductTest from "./user/pages/ProductTest";
import AllGallery from "./user/pages/AllGallery";
import AccountCustomOrder from "./user/pages/account/AccountCustomOrder";
import AccountWallet from "./user/pages/account/AccountWallet";
import RateCalculator from "./user/pages/RateCalculator";
import OffersPage from "./user/pages/OffersPage";
import StoreLocation from "./user/pages/StoreLocation";
import AccountNotification from "./user/pages/account/AccountNotification";
import AccountOffer from "./user/pages/account/AccountOffer";
import AccountMonthly from "./user/pages/account/AccountMonthly";
import AccountRefer from "./user/pages/account/AccountRefer";
import VendorHome from "./user/pages/vendor/VendorHome";
import VendorAllOrder from "./user/pages/vendor/VendorAllOrder";
import VendorAllPendingOrder from "./user/pages/vendor/VendorAllPendingOrder";
import VendorAllCancelOrder from "./user/pages/vendor/VendorAllCancelOrder";
import VendorAllCompleteOrder from "./user/pages/vendor/VendorAllCompleteOrder";
import VendorOrderView from "./user/pages/vendor/VendorOrderView";

const ScrollToTop = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const mainContainer = document.querySelector('main.page-content');
  if (mainContainer) {
    mainContainer.scrollTop = 0; // Scroll to the top of the container
  } else {
    window.scrollTo(0, 0); // Fallback to window scroll if the container is not found
  }


  return null;
};

function App() {


  const location = useLocation(); // Get the current location from React Router
  const isLoginFromLocalStorage = getCookie("token") ? true : false;
  const [isUserAuthenticated, setIsUserAuthenticated] = useState(
    isLoginFromLocalStorage
  );

  const [isUsertype, setisUsertype] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      setIsUserAuthenticated(isLoginFromLocalStorage);
      const mydata = await getDecryptData();
      if (mydata) {
        const mydatatype = mydata.type;
        setisUsertype(mydatatype);
      }

      console.log("mydata", mydata, isLoginFromLocalStorage);

      window.scrollTo(0, 0);
      const timeoutId = setTimeout(() => {
        // const rootElement = document.getElementById("root");
        // if (rootElement.innerHTML === "") {
        //   navigate("/error", { replace: true });
        //   window.location.reload();
        //   setIsError(true);
        //   console.log("error found");
        // }
        // console.log(" found", rootElement);
      }, 1000); // Adjust the timeout duration as needed

      return () => clearTimeout(timeoutId);
    };

    fetchData();
  }, [isLoginFromLocalStorage, location.pathname]);

  return (
    <>
      <BlogProvider>
        <Toaster />

        <Routes>

          <Route path="/" element={isUsertype === 1 ? <VendorHome /> : <Home />} />
          <Route path="/fcm" element={isUsertype === 1 ? <VendorHome /> : <Home />} />

          {/* <Route path="/service" element={<CategoryTest />} /> */}

          {/* <Route path="/product" element={<ProductTest />} /> */}

          <Route path="/product/:slug/" element={<ProductSlug />} />

          {/* <Route path="/signup-user" element={<SignupUserType />} />
          <Route path="/blog/:slug" element={<Blog />} />
          <Route path="/blogs" element={<AllBlogs />} /> */}

          {/* <Route path="/all-gallery" element={<AllGallery />} /> */}

          <Route path="/:id" element={<Category />} />
          <Route
            path="/login"
            element={isUserAuthenticated ? <Account /> : <UserLogin updateAuthStatus={setIsUserAuthenticated} />
            }
          />
          {/* <Route path="/signup" element={<UserSignup />} /> */}
          {/* <Route path="/complete-order" element={
            isUserAuthenticated ? <CompleteOrder /> : <UserLogin updateAuthStatus={setIsUserAuthenticated} />
          } /> */}

          <Route path="/account/all-order" element={
            isUserAuthenticated ? <AccountOrder /> : <UserLogin updateAuthStatus={setIsUserAuthenticated} />
          } />

          <Route path="/all-order" element={
            isUserAuthenticated ? (isUsertype === 1 ? <VendorAllOrder /> : <ErrorPage />) : <UserLogin updateAuthStatus={setIsUserAuthenticated} />
          } />

          <Route path="/pending-order" element={
            isUserAuthenticated ? (isUsertype === 1 ? <VendorAllPendingOrder /> : <ErrorPage />) : <UserLogin updateAuthStatus={setIsUserAuthenticated} />
          } />

          <Route path="/complete-order" element={
            isUserAuthenticated ? (isUsertype === 1 ? <VendorAllCompleteOrder /> : <ErrorPage />) : <UserLogin updateAuthStatus={setIsUserAuthenticated} />
          } />


          <Route path="/cancel-order" element={
            isUserAuthenticated ? (isUsertype === 1 ? <VendorAllCancelOrder /> : <ErrorPage />) : <UserLogin updateAuthStatus={setIsUserAuthenticated} />
          } />

          <Route path="/account/notification" element={
            isUserAuthenticated ? <AccountNotification /> : <UserLogin updateAuthStatus={setIsUserAuthenticated} />
          } />

          <Route path="/account/offer" element={
            isUserAuthenticated ? <AccountOffer /> : <UserLogin updateAuthStatus={setIsUserAuthenticated} />
          } />




          <Route
            path="/account"
            element={
              <Account />
            }
          />



          <Route
            path="/rate-calculator"
            element={
              <RateCalculator />
            }
          />
          <Route
            path="/offer-page"
            element={
              <OffersPage />
            }
          />


          {/* <Route
            path="/wishList"
            element={
              isUserAuthenticated ? <WishList /> : <Navigate to="/login" />
            }
          />



          <Route
            path="/comparsion"
            element={
              isUserAuthenticated ? <Comparsion /> : <Navigate to="/login" />
            }
          /> */}

          <Route
            path="/account"
            element={
              isUserAuthenticated ? <Account /> : <Navigate to="/login" />
            }
          />
          <Route
            path="/account/order/:userId/:orderId"
            element={
              <AccountOrderView />
            }
          />

          <Route
            path="/order/:id"
            element={
              <VendorOrderView />
            }
          />


          <Route path="/account/plan"
            element={
              isUserAuthenticated ? (
                <AccountPlan />
              ) : (
                <Navigate to="/login" />
              )

            }
          />


          <Route
            path="/account/profile"
            element={
              isUserAuthenticated ? (
                <Accountprofile />
              ) : (
                <Navigate to="/login" />
              )
            }
          />

          <Route
            path="/account/profile-kyc"
            element={
              isUserAuthenticated ? (
                <AccountprofileNew />
              ) : (
                <Navigate to="/login" />
              )
            }
          />




          <Route
            path="/account/password"
            element={
              isUserAuthenticated ? (
                <AccountPassword />
              ) : (
                <UserLogin updateAuthStatus={setIsUserAuthenticated} />
              )
            }
          />
          <Route
            path="/account/support"
            element={
              <AccountSupport />
            }
          />
          {/* <Route
            path="/account/all-enquire"
            element={
              isUserAuthenticated ? (
                <AccountAllEnquire />
              ) : (
                <Navigate to="/login" />
              )
            }
          /> */}
          {/* <Route
            path="/account/all-transactions"
            element={
              isUserAuthenticated ? (
                <AccountAllTransactions />
              ) : (
                <Navigate to="/login" />
              )
            }
          /> */}

          <Route
            path="/custom-order"
            element={
              isUserAuthenticated ? (
                <AccountCustomOrder />
              ) : (
                <UserLogin updateAuthStatus={setIsUserAuthenticated} />
              )
            }
          />

          <Route
            path="/wallet"
            element={
              isUserAuthenticated ? (
                <AccountWallet />
              ) : (
                <UserLogin updateAuthStatus={setIsUserAuthenticated} />
              )
            }
          />


          <Route
            path="/account/monthly-investment"
            element={
              isUserAuthenticated ? (
                <AccountMonthly />
              ) : (
                <UserLogin updateAuthStatus={setIsUserAuthenticated} />
              )
            }
          />



          <Route
            path="/account/refer-friend"
            element={
              isUserAuthenticated ? (
                <AccountRefer />
              ) : (
                <UserLogin updateAuthStatus={setIsUserAuthenticated} />
              )
            }
          />



          <Route
            path="/checkout"
            element={<Checkout updateAuthStatus={setIsUserAuthenticated} />}
          />

          <Route path="page/:slug" element={<Page />} />
          <Route path="store-location" element={<StoreLocation />} />
          <Route path="/cart" element={<CartPage />} />

          <Route path="/contact" element={<Contact />} />

          {/* <Route path="/about" element={<About />} /> */}
          {/* <Route path="/contact" element={<Contact />} />

          <Route path="/allblogs" element={<AllBlogs />} />
        
          <Route path="/signup" element={<UserSignup />} />

          <Route path="/product/:id" element={<Product />} />
          <Route path="/product/:slug/" element={<ProductSlug />} /> */}

          {/* <Route
            path="/checkout"
            element={<Checkout updateAuthStatus={setIsUserAuthenticated} />}
          /> */}


          {/* <Route path="/complete-order" element={isUserAuthenticated ? <CompleteOrder /> : <Navigate to="/login" />} /> */}

          {/* <Route path="/complete-order" element={<CompleteOrder />} />

        
          <Route path="/cancel" element={<Cancel />} />

          <Route path="/" element={<Home />} />
 
 
          <Route path="page/:slug" element={<Page />} />


          {/* <Route path="/all-vendor" element={<AllVendors />} />
          <Route path="/vendor/:id" element={<ViewVendor />} />
          <Route path="/checkout-plan/:id" element={<CheckoutPlan />} />
          <Route path="/card-view/:id" element={<CardView />} />


          <Route path="/all-plan" element={<AllPlans />} /> */}


          <Route path="/404" element={<ErrorPage />} />

          {/* <Route path="/payment-success/:id" element={<SuccessPage />} />

          <Route path="/payment-fail/" element={<FailPage />} /> */}

          <Route path="*" element={<ErrorPage />} />


        </Routes>
        <ScrollToTop />
      </BlogProvider>
    </>
  );
}

export default App;
